<template>
<div class="chapter">
<div class="inner_page">
<p class="bk-title"><span>The Lawrence Sanders Thriller Collection Volume Two</span></p>
<p class="bk-title1"><span>The Tomorrow File, The Passion of Molly T., and Capital Crimes</span></p>
<p class="authorname"><span>Lawrence Sanders</span></p>
<p class="publisher"><img alt="image" class="svg" src="images/fig_01.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?09063336